export default __webpack_public_path__ + "static/media/loxan.fb8b8062.jpg";